import { Add, Close, Upload } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  FormLabel,
  ListItem,
  ListItemText,
  Radio,
  RadioGroup,
  TextareaAutosize,
  TextField,
  Typography,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../../../context/AuthContext";
import { LoadingButton } from "@mui/lab";
import moment from "moment";
import { SnackAlertContext } from "../../../../../context/SnackAlertContext";
import { useFormik } from "formik";
import * as Yup from "yup";

const RFPDialog = ({ orderId, open, onClose, onSuccess }) => {
  const { authToken, ezorder } = useContext(AuthContext);
  const { openSnackMessage } = useContext(SnackAlertContext);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [confirmText, setConfirmText] = useState("");

  const handleClose = () => {
    // Reset and close
    setConfirmText("");
    setErrorMessage("");
    onClose();
  };

  const updateOrderReadyForPickup = async (values) => {
    try {
      setErrorMessage("");
      setLoading(true);

      const response = await ezorder.put(
        `/shop/orders/${orderId}/ready-for-pickup`,
        values,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (response.status == 200 || response.status == 201) {
        onSuccess();
      } else {
        console.log(response);
        setErrorMessage(response.response.data.error);
      }
    } catch (error) {
      console.log(error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        setErrorMessage(error.response.data.error);
      } else {
        // Something went really bad
        console.log(error);
        setErrorMessage(error);
      }
    } finally {
      setLoading(false);
    }
  };

  const formValidationSchema = Yup.object({
    text: Yup.string(),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      text: "",
    },
    validationSchema: formValidationSchema,
    validateOnBlur: false,
    validateOnChange: true,
    onSubmit: (values) => {
      //   createConsumable(values.description, values.uom, values.retailPrice);
      updateOrderReadyForPickup(values);
    },
  });

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={() => {
        if (!loading) {
          handleClose();
        }
      }}
    >
      <DialogTitle>Ready For Pickup #{orderId}</DialogTitle>
      <DialogContent>
        <TextareaAutosize
          placeholder="What is Ready For Pickup?"
          style={{
            width: "100%",
            marginTop: "8px",
            // color: "#fff",
            flex: 1,
          }}
          fullWidth
          minRows={3}
          value={formik.values.text}
          onChange={(e) => {
            formik.setFieldValue("text", e.target.value);
          }}
        />
      </DialogContent>
      <Box
        sx={{
          m: 1,
          position: "relative",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {errorMessage && (
          <Box>
            <Typography color={"red"}>{errorMessage}</Typography>
          </Box>
        )}
      </Box>
      <DialogActions>
        <LoadingButton
          loading={loading}
          onClick={() => {
            if (!loading) handleClose();
          }}
        >
          Cancel
        </LoadingButton>
        <LoadingButton
          disabled={!formik.values.text}
          loading={loading}
          variant="contained"
          color="primary"
          onClick={() => {
            formik.handleSubmit();
          }}
        >
          Submit
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default RFPDialog;
